import FormControl from '@mui/material/FormControl';
import { FormControlProps } from '@mui/material/FormControl';

// interface BaseFormControlProps extends Omit<FormControlProps, 'children'> {
//     children: ReactNode;
// }
function BaseFormControl({ ...props }: FormControlProps) {
    return <FormControl {...props} />;
}

export default BaseFormControl;
